import {  DocumentCategoryApi } from "../openapi";
import openApiConfig from "./http_service";

const documentCategoryApi=new DocumentCategoryApi(openApiConfig)

export default documentCategoryApi